import classNames from 'classnames';

export default function TabBar(props) {
    const { active = 0 } = props;

    const tabs = {
        'My Details': '/mydmc/account',
        'My Company': '/mydmc/account/company',
        'My Team': '/mydmc/account/company/team',
        'Billing': '/mydmc/account/billing',
        'Membership Plan': '/mydmc/account/memberships',
    }

    return <div className="tab-bar">
        { Object.keys(tabs).map((key, index) => {
            const url = tabs[key];

            const classes = classNames({
                'tab-bar__link': true,
                'tab-bar__link--active': active === index
            })

            return <a className={classes} href={url}>{ key }</a>
        }) }
    </div>
}